export class SearchHistory{
    public id: string;
    public searchTerm: string;
    public historyType: string;
    public contentCategories: Array<{alias:string, itemcount:number, isActive:boolean}>;
    public contentShowOverlay: boolean;
    public searchType: string;
    public productFilter: string;
    public selectedIndex: number;
    public itemCount: number;
    // public psItemsCount: number;
    // public psSuggest: boolean;
    // public psSelected: string;
    // public psLoc: string;
    // public psType: string;
    // public psLocOrigin: string|null;
    // public csHideOverlay: boolean; 
    // public praeparat: string;
    // public product: string;
    // public isFromExtern: boolean;

    constructor(item:any){
        this.id = item.id ?? null;
        this.searchTerm = item.searchTerm ?? null;
        this.historyType = item.historyType ?? "praeparat";
        this.contentCategories = item.contentCategories ?? [] as {alias:string, itemcount:number, isActive:boolean}[];
        this.contentShowOverlay = item.contentShowOverlay ?? false;
        this.searchType = item.searchType ?? "default";
        this.productFilter = item.productFilter ?? null;
        this.selectedIndex = item.selectedIndex ?? 0;
        this.itemCount = item.itemCount ?? 0;
        // this.psType = item.psType ?? null;
        // // this.psItemsCount = item.psItemsCount ?? 0;
        // // this.psSuggest = item.psSuggest ?? false;
        // this.psSelected = item.psSelected ?? null;
        // this.psLoc = item.psLoc ?? null;
        // this.psLocOrigin = item.psLocOrigin ?? null;
        // this.praeparat = item.praeparat ?? null;
        // this.product = item.product ?? null;
        // this.isFromExtern = item.isFromExtern ?? false;
    }
}